// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Info = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <circle cx='24' cy='24' r='22' />
      <line x1='24' y1='33.4' x2='24' y2='20.2' />
      <circle cx='24' cy='15.1' r='.5' />
    </svg>
  );
};
